'use strict';

exports.__esModule = true;
exports.FileInput = exports.SingleUploader = exports.MultiUploader = exports.Uploader = exports.styles = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MultiUploader = require('./components/MultiUploader');

var _MultiUploader2 = _interopRequireDefault(_MultiUploader);

var _SingleUploader = require('./components/SingleUploader');

var _SingleUploader2 = _interopRequireDefault(_SingleUploader);

var _CloudUpload = require('material-ui-icons/CloudUpload');

var _CloudUpload2 = _interopRequireDefault(_CloudUpload);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _Typography = require('material-ui/Typography');

var _Typography2 = _interopRequireDefault(_Typography);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _CircularProgress = require('material-ui/Progress/CircularProgress');

var _CircularProgress2 = _interopRequireDefault(_CircularProgress);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    inputRoot: {
      minHeight: 54,
      maxWidth: 210,
      padding: "0 10px",
      display: "inline-flex",
      flexDirection: "row",
      alignItems: "center",
      border: "2px dotted #ddd",
      "&:hover": {
        borderColor: "#bbb",
        cursor: "pointer"
      }
    },
    dropable: {
      background: "rgba(255,255,0, 0.2)"
    },
    helperText: {
      marginLeft: 10
    }
  };
};

var FileInput = (_temp = _class = function (_Component) {
  _inherits(FileInput, _Component);

  function FileInput(props) {
    _classCallCheck(this, FileInput);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = _this.getInitialStore();
    return _this;
  }

  FileInput.prototype.getInitialStore = function getInitialStore() {
    return {
      allowDrop: false
    };
  };

  FileInput.prototype.resetStore = function resetStore() {
    this.setState(_extends({}, this.getInitialStore()));
  };

  FileInput.prototype.getItems = function getItems(event) {
    var items = [];

    if (event.dataTransfer && event.dataTransfer.items) {
      for (var i = 0; i < event.dataTransfer.items.length; i++) {
        var item = event.dataTransfer.items[i];
        items.push(item);
      }
    }

    return items;
  };

  FileInput.prototype.onDrop = function onDrop(event) {
    event.preventDefault();
    var valid = true;
    var files = event.dataTransfer.files;
    this.onChange({
      target: {
        validity: {
          valid: valid
        },
        files: files
      }
    });
    this.resetStore();
  };

  FileInput.prototype.onChange = function onChange(event) {
    var onChange = this.props.onChange;
    onChange(event);
  };

  FileInput.prototype.onDragOver = function onDragOver(event) {
    event.preventDefault();
    var allowDrop = this.state.allowDrop;

    if (!allowDrop) {
      this.setState({
        allowDrop: this.isAllowDrop(event)
      });
    }
  };

  FileInput.prototype.isAllowDrop = function isAllowDrop(event) {
    return true;
  };

  FileInput.prototype.hasImages = function hasImages(event) {
    return this.getItems(event).findIndex(function (n) {
      return n.kind === "file" && /^image\//i.test(n.type);
    }) !== -1;
  };

  FileInput.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        onClick = _props.onClick,
        onChange = _props.onChange,
        multiple = _props.multiple,
        classes = _props.classes,
        helperText = _props.helperText,
        children = _props.children,
        className = _props.className,
        accept = _props.accept,
        loading = _props.loading,
        other = _objectWithoutProperties(_props, ['onClick', 'onChange', 'multiple', 'classes', 'helperText', 'children', 'className', 'accept', 'loading']);

    var allowDrop = this.state.allowDrop;

    var input = _react2.default.createElement('input', {
      type: 'file',
      multiple: multiple,
      accept: accept,
      ref: function ref(input) {
        _this2.input = input;
      },
      onChange: onChange,
      style: {
        display: "none"
      }
    });

    return _react2.default.createElement('div', _extends({
      className: [className, classes.inputRoot, allowDrop ? classes.dropable : ""].join(" "),
      onDragEnter: function onDragEnter(event) {
        event.preventDefault();
      },
      onDragStart: function onDragStart(event) {
        event.preventDefault();
      },
      onDragOver: function onDragOver(event) {
        return _this2.onDragOver(event);
      },
      onDragLeave: function onDragLeave(event) {
        event.preventDefault();

        _this2.resetStore();
      },
      onDrop: function onDrop(event) {
        return _this2.onDrop(event);
      },
      onClick: function onClick(event) {
        _this2.input.click();
      }
    }, other), input, children || _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_IconButton2.default, null, loading ? _react2.default.createElement(_CircularProgress2.default, null) : _react2.default.createElement(_CloudUpload2.default, {
      className: classes.icon
    })), helperText ? _react2.default.createElement(_Typography2.default, {
      component: 'span',
      className: classes.helperText
    }, helperText) : null));
  };

  return FileInput;
}(_react.Component), _class.defaultProps = {
  helperText: "\u0414\u043B\u044F \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u043F\u0435\u0440\u0435\u0442\u0430\u0449\u0438\u0442\u0435 \u0444\u0430\u0439\u043B\u044B \u0441\u044E\u0434\u0430"
}, _temp);
FileInput.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: _propTypes2.default.object.isRequired,
  helperText: _propTypes2.default.string,
  accept: _propTypes2.default.string,
  loading: _propTypes2.default.bool.isRequired
} : {};
var Uploader = (_temp2 = _class2 = function (_Component2) {
  _inherits(Uploader, _Component2);

  function Uploader() {
    _classCallCheck(this, Uploader);

    return _possibleConstructorReturn(this, _Component2.apply(this, arguments));
  }

  Uploader.prototype.render = function render() {
    var _props2 = this.props,
        FileInput = _props2.FileInput,
        multiple = _props2.multiple,
        other = _objectWithoutProperties(_props2, ['FileInput', 'multiple']);

    var Component = multiple ? _MultiUploader2.default : _SingleUploader2.default;
    return _react2.default.createElement(Component, _extends({
      FileInput: FileInput,
      multiple: multiple
    }, other));
  };

  return Uploader;
}(_react.Component), _class2.defaultProps = {
  multiple: false,
  FileInput: FileInput
}, _temp2);
Uploader.propTypes = process.env.NODE_ENV !== "production" ? {
  multiple: _propTypes2.default.bool.isRequired,
  FileInput: _propTypes2.default.func.isRequired
} : {};
exports.styles = styles;
exports.Uploader = Uploader;
exports.MultiUploader = _MultiUploader2.default;
exports.SingleUploader = _SingleUploader2.default;
exports.FileInput = FileInput;
exports.default = (0, _withStyles2.default)(styles)(Uploader);